import { MprcRibbonGenericCard } from "components/MprcRibbonList/MprcRibbonGenericCard";
import { MprcRibbonListTabbed, MprcRibbonListTabbedHandle, MprcRibbonTabbedItem } from "components/MprcRibbonList/MprcRibbonListTabbed";
import { BuildRibbonCards } from "./BuildRibbonCards";
import { MprcRibbonList, MprcRibbonListHandle } from "./MprcRibbonList";
import { MprcRibbonListCardsExpandedContainer, MprcRibbonListCardsPortalContainer, MprcRibbonListCardsWrapContainer } from "./MprcRibbonListCardContainers";
import { MprcRibbonListContainer } from "./MprcRibbonListContainer";

export { BuildRibbonCards, MprcRibbonList, MprcRibbonListContainer, MprcRibbonListCardsExpandedContainer, MprcRibbonListCardsWrapContainer, MprcRibbonListCardsPortalContainer, MprcRibbonGenericCard };
export type { MprcRibbonTabbedItem, MprcRibbonListHandle, MprcRibbonListTabbedHandle };

export type MprcCardRibbonData = {
    id: string;
    thumbnail: React.ReactNode;
    thumbStickerLeft?: React.ReactNode;
    thumbStickerRight?: React.ReactNode;
    body: React.ReactNode;
    actions: React.ReactNode;
};

export const MprcRibbonTabbed = {
    Container: MprcRibbonListContainer,
    ExpandedContainer: MprcRibbonListCardsExpandedContainer,
    Tab: MprcRibbonListTabbed
};
